module.exports = __webpack_public_path__ + "static/img/ico_profilecard_exclamationmark.c33cda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_profilecard_exclamationmark.png
// module id = IA13
// module chunks = 1